export function interpolatePath(path: string, value: Record<string, string>): string {
    Object.keys(value).forEach((key) => {
        path = path.replace(`:${key}`, value[key]);
    });

    return path;
}
